// src/enums.ts
var SystemRole = /* @__PURE__ */ ((SystemRole2) => {
  SystemRole2["ADMIN"] = "ADMIN";
  return SystemRole2;
})(SystemRole || {});
var FranchiseRole = /* @__PURE__ */ ((FranchiseRole2) => {
  FranchiseRole2["OWNER"] = "OWNER";
  FranchiseRole2["MANAGER"] = "MANAGER";
  FranchiseRole2["STAFF"] = "STAFF";
  return FranchiseRole2;
})(FranchiseRole || {});
var RestaurantRole = /* @__PURE__ */ ((RestaurantRole2) => {
  RestaurantRole2["MANAGER"] = "MANAGER";
  RestaurantRole2["STAFF"] = "STAFF";
  RestaurantRole2["KITCHEN"] = "KITCHEN";
  RestaurantRole2["CASHIER"] = "CASHIER";
  return RestaurantRole2;
})(RestaurantRole || {});
var PartnerRole = /* @__PURE__ */ ((PartnerRole2) => {
  PartnerRole2["ADMIN"] = "ADMIN";
  PartnerRole2["MEMBER"] = "MEMBER";
  return PartnerRole2;
})(PartnerRole || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["PENDING"] = "PENDING";
  OrderStatus2["CONFIRMED"] = "CONFIRMED";
  OrderStatus2["COMPLETED"] = "COMPLETED";
  OrderStatus2["CANCELLED"] = "CANCELLED";
  return OrderStatus2;
})(OrderStatus || {});
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["DINE_IN"] = "DINE_IN";
  OrderType2["PICKUP"] = "PICKUP";
  OrderType2["DELIVERY"] = "DELIVERY";
  return OrderType2;
})(OrderType || {});
var LocalOrderStatus = /* @__PURE__ */ ((LocalOrderStatus2) => {
  LocalOrderStatus2["PENDING"] = "PENDING";
  LocalOrderStatus2["PREPARING"] = "PREPARING";
  LocalOrderStatus2["READY"] = "READY";
  LocalOrderStatus2["SERVED"] = "SERVED";
  return LocalOrderStatus2;
})(LocalOrderStatus || {});
var OrderItemStatus = /* @__PURE__ */ ((OrderItemStatus2) => {
  OrderItemStatus2["PENDING"] = "PENDING";
  OrderItemStatus2["PREPARING"] = "PREPARING";
  OrderItemStatus2["READY"] = "READY";
  OrderItemStatus2["SERVED"] = "SERVED";
  return OrderItemStatus2;
})(OrderItemStatus || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["CASH"] = "CASH";
  PaymentMethod2["CARD"] = "CARD";
  return PaymentMethod2;
})(PaymentMethod || {});
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus3) => {
  PaymentStatus3["PENDING_COLLECTION"] = "PENDING_COLLECTION";
  PaymentStatus3["AWAITING_PROOF"] = "AWAITING_PROOF";
  PaymentStatus3["PROOF_SUBMITTED"] = "PROOF_SUBMITTED";
  PaymentStatus3["PROCESSING"] = "PROCESSING";
  PaymentStatus3["ON_HOLD"] = "ON_HOLD";
  PaymentStatus3["PAID"] = "PAID";
  PaymentStatus3["REJECTED"] = "REJECTED";
  PaymentStatus3["VOID"] = "VOID";
  PaymentStatus3["REFUNDED"] = "REFUNDED";
  PaymentStatus3["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
  return PaymentStatus3;
})(PaymentStatus || {});
var PaymentMethodKind = /* @__PURE__ */ ((PaymentMethodKind3) => {
  PaymentMethodKind3["ONLINE"] = "ONLINE";
  PaymentMethodKind3["MANUAL"] = "MANUAL";
  PaymentMethodKind3["CASH"] = "CASH";
  PaymentMethodKind3["CARD_ON_HANDOFF"] = "CARD_ON_HANDOFF";
  PaymentMethodKind3["GIFT_CARD"] = "GIFT_CARD";
  return PaymentMethodKind3;
})(PaymentMethodKind || {});
var CollectionMode = /* @__PURE__ */ ((CollectionMode2) => {
  CollectionMode2["MANUAL"] = "MANUAL";
  CollectionMode2["AUTO"] = "AUTO";
  return CollectionMode2;
})(CollectionMode || {});
var DeliveryZoneMode = /* @__PURE__ */ ((DeliveryZoneMode2) => {
  DeliveryZoneMode2["STRAIGHT_LINE"] = "STRAIGHT_LINE";
  DeliveryZoneMode2["POLYGON"] = "POLYGON";
  DeliveryZoneMode2["ROUTE_DISTANCE"] = "ROUTE_DISTANCE";
  return DeliveryZoneMode2;
})(DeliveryZoneMode || {});
var RefundReason = /* @__PURE__ */ ((RefundReason2) => {
  RefundReason2["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
  RefundReason2["WRONG_ITEM"] = "WRONG_ITEM";
  RefundReason2["LATE_DELIVERY"] = "LATE_DELIVERY";
  RefundReason2["CANCELLED_BY_OWNER"] = "CANCELLED_BY_OWNER";
  RefundReason2["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
  RefundReason2["OTHER"] = "OTHER";
  return RefundReason2;
})(RefundReason || {});
var CancelActor = /* @__PURE__ */ ((CancelActor2) => {
  CancelActor2["OWNER"] = "OWNER";
  CancelActor2["STAFF"] = "STAFF";
  CancelActor2["CUSTOMER"] = "CUSTOMER";
  CancelActor2["SYSTEM"] = "SYSTEM";
  return CancelActor2;
})(CancelActor || {});
var ReservationStatus = /* @__PURE__ */ ((ReservationStatus2) => {
  ReservationStatus2["PENDING"] = "PENDING";
  ReservationStatus2["CONFIRMED"] = "CONFIRMED";
  ReservationStatus2["REJECTED"] = "REJECTED";
  ReservationStatus2["CANCELLED"] = "CANCELLED";
  return ReservationStatus2;
})(ReservationStatus || {});
var ArrivalStatus = /* @__PURE__ */ ((ArrivalStatus2) => {
  ArrivalStatus2["WAITING"] = "WAITING";
  ArrivalStatus2["ARRIVED"] = "ARRIVED";
  ArrivalStatus2["SEATED"] = "SEATED";
  ArrivalStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  ArrivalStatus2["COMPLETED"] = "COMPLETED";
  ArrivalStatus2["NO_SHOW"] = "NO_SHOW";
  ArrivalStatus2["RESCHEDULED"] = "RESCHEDULED";
  return ArrivalStatus2;
})(ArrivalStatus || {});
var ReservationSource = /* @__PURE__ */ ((ReservationSource2) => {
  ReservationSource2["ONLINE"] = "ONLINE";
  ReservationSource2["PHONE"] = "PHONE";
  ReservationSource2["WALK_IN"] = "WALK_IN";
  ReservationSource2["THIRD_PARTY"] = "THIRD_PARTY";
  return ReservationSource2;
})(ReservationSource || {});
var AutoConfirmMode = /* @__PURE__ */ ((AutoConfirmMode2) => {
  AutoConfirmMode2["AUTO"] = "AUTO";
  AutoConfirmMode2["MANUAL"] = "MANUAL";
  return AutoConfirmMode2;
})(AutoConfirmMode || {});
var ArrivalTrackingMode = /* @__PURE__ */ ((ArrivalTrackingMode2) => {
  ArrivalTrackingMode2["SIMPLE"] = "SIMPLE";
  ArrivalTrackingMode2["ADVANCED"] = "ADVANCED";
  return ArrivalTrackingMode2;
})(ArrivalTrackingMode || {});
var ShiftMode = /* @__PURE__ */ ((ShiftMode2) => {
  ShiftMode2["SIMPLE"] = "SIMPLE";
  ShiftMode2["ADVANCED"] = "ADVANCED";
  return ShiftMode2;
})(ShiftMode || {});
var ShiftScope = /* @__PURE__ */ ((ShiftScope2) => {
  ShiftScope2["BASELINE"] = "BASELINE";
  ShiftScope2["WINDOW"] = "WINDOW";
  return ShiftScope2;
})(ShiftScope || {});
var TableAttribute = /* @__PURE__ */ ((TableAttribute2) => {
  TableAttribute2["WINDOW"] = "WINDOW";
  TableAttribute2["BOOTH"] = "BOOTH";
  TableAttribute2["OUTDOOR"] = "OUTDOOR";
  TableAttribute2["BAR"] = "BAR";
  TableAttribute2["HIGH_TOP"] = "HIGH_TOP";
  TableAttribute2["PRIVATE_ROOM"] = "PRIVATE_ROOM";
  TableAttribute2["QUIET"] = "QUIET";
  TableAttribute2["WHEELCHAIR"] = "WHEELCHAIR";
  TableAttribute2["NEAR_FIREPLACE"] = "NEAR_FIREPLACE";
  TableAttribute2["KIDS_FRIENDLY"] = "KIDS_FRIENDLY";
  return TableAttribute2;
})(TableAttribute || {});
var TableSessionStatus = /* @__PURE__ */ ((TableSessionStatus2) => {
  TableSessionStatus2["OPEN"] = "OPEN";
  TableSessionStatus2["BILL_REQUESTED"] = "BILL_REQUESTED";
  TableSessionStatus2["CLOSED"] = "CLOSED";
  return TableSessionStatus2;
})(TableSessionStatus || {});
var TableState = /* @__PURE__ */ ((TableState2) => {
  TableState2["AVAILABLE"] = "AVAILABLE";
  TableState2["OCCUPIED"] = "OCCUPIED";
  TableState2["RESERVED"] = "RESERVED";
  return TableState2;
})(TableState || {});
var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2["BASE"] = "BASE";
  ServiceType2["PICKUP"] = "PICKUP";
  ServiceType2["DELIVERY"] = "DELIVERY";
  ServiceType2["RESERVATION"] = "RESERVATION";
  return ServiceType2;
})(ServiceType || {});
var ExceptionType = /* @__PURE__ */ ((ExceptionType2) => {
  ExceptionType2["CLOSED"] = "CLOSED";
  ExceptionType2["MODIFIED"] = "MODIFIED";
  return ExceptionType2;
})(ExceptionType || {});
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2[DayOfWeek2["SUNDAY"] = 0] = "SUNDAY";
  DayOfWeek2[DayOfWeek2["MONDAY"] = 1] = "MONDAY";
  DayOfWeek2[DayOfWeek2["TUESDAY"] = 2] = "TUESDAY";
  DayOfWeek2[DayOfWeek2["WEDNESDAY"] = 3] = "WEDNESDAY";
  DayOfWeek2[DayOfWeek2["THURSDAY"] = 4] = "THURSDAY";
  DayOfWeek2[DayOfWeek2["FRIDAY"] = 5] = "FRIDAY";
  DayOfWeek2[DayOfWeek2["SATURDAY"] = 6] = "SATURDAY";
  return DayOfWeek2;
})(DayOfWeek || {});
var TimeFormat = /* @__PURE__ */ ((TimeFormat2) => {
  TimeFormat2["TWELVE_HOUR"] = "12h";
  TimeFormat2["TWENTY_FOUR_HOUR"] = "24h";
  return TimeFormat2;
})(TimeFormat || {});
var DeliveryPriceMode = /* @__PURE__ */ ((DeliveryPriceMode2) => {
  DeliveryPriceMode2["DISTANCE"] = "DISTANCE";
  DeliveryPriceMode2["ZONE"] = "ZONE";
  return DeliveryPriceMode2;
})(DeliveryPriceMode || {});
var DistanceCalculation = /* @__PURE__ */ ((DistanceCalculation2) => {
  DistanceCalculation2["DIRECT"] = "DIRECT";
  DistanceCalculation2["ROUTE"] = "ROUTE";
  return DistanceCalculation2;
})(DistanceCalculation || {});
var PauseMode = /* @__PURE__ */ ((PauseMode2) => {
  PauseMode2["TIMED"] = "TIMED";
  PauseMode2["UNTIL_CLOSE"] = "UNTIL_CLOSE";
  return PauseMode2;
})(PauseMode || {});
var Allergen = /* @__PURE__ */ ((Allergen2) => {
  Allergen2["CELERY"] = "CELERY";
  Allergen2["CEREALS"] = "CEREALS";
  Allergen2["CRUSTACEANS"] = "CRUSTACEANS";
  Allergen2["EGGS"] = "EGGS";
  Allergen2["FISH"] = "FISH";
  Allergen2["LUPIN"] = "LUPIN";
  Allergen2["MILK"] = "MILK";
  Allergen2["MOLLUSCS"] = "MOLLUSCS";
  Allergen2["MUSTARD"] = "MUSTARD";
  Allergen2["NUTS"] = "NUTS";
  Allergen2["PEANUTS"] = "PEANUTS";
  Allergen2["SESAME"] = "SESAME";
  Allergen2["SOYBEANS"] = "SOYBEANS";
  Allergen2["SULPHITES"] = "SULPHITES";
  return Allergen2;
})(Allergen || {});
var ProductLabel = /* @__PURE__ */ ((ProductLabel2) => {
  ProductLabel2["VEGAN"] = "VEGAN";
  ProductLabel2["VEGETARIAN"] = "VEGETARIAN";
  ProductLabel2["GLUTEN_FREE"] = "GLUTEN_FREE";
  ProductLabel2["LACTOSE_FREE"] = "LACTOSE_FREE";
  ProductLabel2["SPICY"] = "SPICY";
  ProductLabel2["HALAL"] = "HALAL";
  ProductLabel2["KOSHER"] = "KOSHER";
  ProductLabel2["ORGANIC"] = "ORGANIC";
  ProductLabel2["NEW"] = "NEW";
  ProductLabel2["POPULAR"] = "POPULAR";
  ProductLabel2["CHEF_SPECIAL"] = "CHEF_SPECIAL";
  return ProductLabel2;
})(ProductLabel || {});
var NotificationChannel = /* @__PURE__ */ ((NotificationChannel2) => {
  NotificationChannel2["PUSH"] = "PUSH";
  NotificationChannel2["EMAIL"] = "EMAIL";
  NotificationChannel2["SMS"] = "SMS";
  return NotificationChannel2;
})(NotificationChannel || {});
var PurgeTarget = /* @__PURE__ */ ((PurgeTarget2) => {
  PurgeTarget2["ORDER"] = "ORDER";
  PurgeTarget2["RESERVATION"] = "RESERVATION";
  return PurgeTarget2;
})(PurgeTarget || {});
var PurgeSource = /* @__PURE__ */ ((PurgeSource2) => {
  PurgeSource2["SCHEDULED"] = "SCHEDULED";
  PurgeSource2["MANUAL_RULE"] = "MANUAL_RULE";
  PurgeSource2["MANUAL_CRITERIA"] = "MANUAL_CRITERIA";
  PurgeSource2["MANUAL_SELECTION"] = "MANUAL_SELECTION";
  return PurgeSource2;
})(PurgeSource || {});
var PurgeAgeBasis = /* @__PURE__ */ ((PurgeAgeBasis2) => {
  PurgeAgeBasis2["CREATED_AT"] = "CREATED_AT";
  PurgeAgeBasis2["SERVICE_TIME"] = "SERVICE_TIME";
  return PurgeAgeBasis2;
})(PurgeAgeBasis || {});
var PurgeLabelMatch = /* @__PURE__ */ ((PurgeLabelMatch2) => {
  PurgeLabelMatch2["ANY"] = "ANY";
  PurgeLabelMatch2["ALL"] = "ALL";
  return PurgeLabelMatch2;
})(PurgeLabelMatch || {});
var PurgeScheduleKind = /* @__PURE__ */ ((PurgeScheduleKind2) => {
  PurgeScheduleKind2["DAILY"] = "DAILY";
  PurgeScheduleKind2["WEEKLY"] = "WEEKLY";
  PurgeScheduleKind2["MONTHLY"] = "MONTHLY";
  return PurgeScheduleKind2;
})(PurgeScheduleKind || {});
var PurgeRunStatus = /* @__PURE__ */ ((PurgeRunStatus2) => {
  PurgeRunStatus2["RUNNING"] = "RUNNING";
  PurgeRunStatus2["COMPLETED"] = "COMPLETED";
  PurgeRunStatus2["PARTIAL"] = "PARTIAL";
  PurgeRunStatus2["FAILED"] = "FAILED";
  return PurgeRunStatus2;
})(PurgeRunStatus || {});

// src/localized.ts
function resolveLocalized(value, language) {
  if (!value) return void 0;
  return value[language] ?? value.en ?? Object.values(value).find((v) => v != null);
}
function resolveLocalizedJson(value, language) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return void 0;
  const map = {};
  for (const [key, entry] of Object.entries(value)) {
    if (typeof entry === "string") map[key] = entry;
  }
  return resolveLocalized(map, language);
}

// src/errors.ts
var ERROR_STATUS = {
  "order.slotFull": 422,
  "order.belowMinOrder": 422,
  "order.leadTimeViolation": 422,
  "order.outsideDeliveryZone": 400,
  // Route-distance pricing couldn't reach MapBox to quote a fee. Transient
  // external failure → 503 so the customer can retry; never silently falls
  // back to haversine (the quoted fee must match the configured basis).
  "order.deliveryFeeUnavailable": 503,
  // The submitted delivery address couldn't be geocoded to coordinates, so
  // distance can't be computed. A permanent, customer-fixable input problem
  // (NOT a transient MapBox outage) → 400, so it stays out of the 5xx ERROR /
  // Telegram path. Distinct from deliveryFeeUnavailable (503, MapBox unreachable).
  "order.deliveryAddressUnlocatable": 400,
  "order.prepAlreadyStarted": 409,
  // Owner tried to bare-accept an order whose payment is still on the customer's
  // / gateway's / proof-review side (manual awaiting/submitted proof, online
  // processing). Those confirm via their own rail (accept-proof / reconcile),
  // never plain accept. 409 = the order isn't in an acceptable state yet.
  "order.paymentNotReady": 409,
  // Accept lost a race: the order was no longer PENDING. Two codes, not one,
  // because the dashboard handles them oppositely — moved forward means the
  // owner's intent already happened (re-converge silently), cancelled is news.
  "order.alreadyConfirmed": 409,
  "order.alreadyCancelled": 409,
  "order.itemOutOfStock": 400,
  "order.orderingPaused": 409,
  // Checkout-time rejections surfaced to the customer with a specific reason
  // (were bare BadRequestExceptions → generic system.badRequest). 400 = the
  // submitted order can't be placed as-is; the customer must change something.
  "order.orderTypeUnavailable": 400,
  "order.cashPaymentUnavailable": 400,
  "order.cardPaymentUnavailable": 400,
  "order.cardOnHandoffUnavailable": 400,
  "order.paymentMethodRequired": 400,
  "order.promotionInvalid": 400,
  "order.restaurantClosed": 400,
  "order.cartItemUnavailable": 400,
  "order.itemNotAvailableAtTime": 400,
  "order.optionSelectionInvalid": 400,
  "order.deliveryAddressRequired": 400,
  // A booking/order phone couldn't be parsed to a valid number (E.164) for the
  // restaurant's country — the phone is the guest's primary contact + identity
  // key, so an unreachable number is rejected at the boundary.
  // The restaurant has no menu published for this ordering channel. Typed, not a
  // bare 404, because it is OUR outage (an onboarding or import that never
  // activated a menu) rather than a guest asking for something that isn't there
  // — the guest sees a real reason, and alerting can count the code.
  "menu.noActiveMenu": 404,
  "menu.productCodeTaken": 409,
  "menu.optionLimitOutOfRange": 400,
  "customer.invalidPhone": 400,
  "payment.refundExceedsRemaining": 422,
  "payment.voidNoRefund": 409,
  "payment.onlineRefundUnsupported": 422,
  // The external gateway (PayPal / Paycat) failed or was unreachable while
  // opening the checkout. Transient and none of the customer's doing → 503, and
  // the storefront offers another payment method instead of "something went wrong".
  "payment.providerUnavailable": 503,
  "payment.providerAuthFailed": 422,
  "payment.providerUnreachable": 503,
  "payment.providerHostModeMismatch": 422,
  "payment.encryptionNotConfigured": 503,
  // Reservation setup — a WINDOW shift overlaps another on a shared day+time.
  "reservation.shiftOverlap": 409,
  // All four fire when the storefront's slot snapshot goes stale mid-form. 422
  // mirrors the ordering side's `order.slotFull`; the pause stays 400 because the
  // guest route only declares 201/400/404/422.
  "reservation.slotTooLate": 400,
  "reservation.slotInPast": 400,
  "reservation.slotUnavailable": 422,
  "reservation.bookingsPaused": 400,
  "reservation.notEditable": 409,
  "reservation.statusChanged": 409,
  // Opening-hours exception (holiday/special hours) whose date range + service
  // scope overlaps an existing exception. 409 so the dashboard shows the real
  // conflict instead of a bare status code.
  "openingHours.exceptionOverlap": 409,
  "openingHours.shiftsOverlap": 400,
  "openingHours.shiftTimesEqual": 400,
  "openingHours.invalidTimeFormat": 400,
  // Personal-coupon issuance — a customer may hold only one coupon per promotion,
  // and a code is unique per restaurant. Distinct codes so the dashboard can name
  // which clash occurred instead of a generic conflict.
  "promotion.couponAlreadyIssued": 409,
  "promotion.codeInUse": 409,
  // Hand-pressed "print the bon" on an order. Typed rather than bare
  // ConflictExceptions because the filter replaces a plain exception's message
  // with the status string — the owner would read "409" in the toast.
  "print.noPrinterConfigured": 409,
  "print.notPrintable": 409,
  "system.validationFailed": 422,
  "system.unauthenticated": 401,
  "system.forbidden": 403,
  "system.notFound": 404,
  "system.conflict": 409,
  "system.badRequest": 400,
  "system.internal": 500,
  // Staff (worker) management — distinct codes so the dashboard can show
  // a specific message per failure instead of a generic conflict/not-found.
  "worker.notFound": 404,
  "worker.notAssigned": 404,
  "worker.alreadyAssigned": 409,
  "worker.emailTaken": 409,
  "worker.lastManager": 409,
  "worker.selfRoleChange": 400,
  "worker.selfDeactivate": 400,
  "partner.selfRoleChange": 400,
  "partner.selfRemove": 400,
  "partner.lastGroupAdmin": 409,
  "partner.memberInactive": 409,
  "partner.memberChanged": 409,
  "worker.lastOwner": 409,
  "user.emailTaken": 409,
  "user.selfRevokeAdmin": 400,
  "user.lastSystemAdmin": 409,
  "label.systemOwned": 409,
  "label.inUseByRule": 409,
  "purge.previewOutdated": 409
};
var ALL_ERROR_CODES = Object.keys(ERROR_STATUS);

// src/money.ts
function minorUnitFactor(currency) {
  try {
    const digits = new Intl.NumberFormat(void 0, {
      style: "currency",
      currency
    }).resolvedOptions().maximumFractionDigits ?? 2;
    return 10 ** digits;
  } catch {
    return 100;
  }
}
function formatMoney(minor, currency, locale) {
  const major = minor / minorUnitFactor(currency);
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency }).format(major);
  } catch {
    return `${major} ${currency}`;
  }
}
function toMinorUnits(major, currency) {
  return Math.round(major * minorUnitFactor(currency));
}
function moneyToInput(minor, currency) {
  const factor = minorUnitFactor(currency);
  const digits = Math.round(Math.log10(factor));
  return (minor / factor).toFixed(digits);
}
function inputToMinor(value, currency) {
  const n = Number.parseFloat(String(value).replace(",", "."));
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.round(n * minorUnitFactor(currency));
}

// src/delivery-zones.ts
function targetZoneMode(priceMode, distanceCalculation) {
  if (priceMode === "ZONE") return "POLYGON";
  return distanceCalculation === "ROUTE" ? "ROUTE_DISTANCE" : "STRAIGHT_LINE";
}
function needsStaticDeliveryMinutes(mode) {
  return mode !== "ROUTE_DISTANCE";
}

// src/order-lines.ts
function formatOrderLineChoices(choices) {
  return choices.map((c) => {
    const option = c.optionNameSnapshot.trim();
    const choice = c.choiceNameSnapshot.trim();
    return option ? `${option}: ${choice}` : choice;
  });
}

// src/product-code.ts
var PRODUCT_CODE_MAX_LENGTH = 12;
var PRODUCT_CODE_SEPARATOR = " \xB7 ";
function normalizeProductCode(raw) {
  if (raw == null) return null;
  const trimmed = raw.trim().replace(/\s+/g, " ");
  return trimmed.length === 0 ? null : trimmed;
}
function productCodeKey(raw) {
  const normalized = normalizeProductCode(raw);
  return normalized === null ? null : normalized.toUpperCase();
}
function formatProductLabel(code, name) {
  const c = normalizeProductCode(code);
  return c ? `${c}${PRODUCT_CODE_SEPARATOR}${name}` : name;
}

// src/client-errors.ts
var ApiError = class _ApiError extends Error {
  constructor(code, params, fieldErrors, detail = void 0, traceId = void 0, status = void 0) {
    super(detail ?? code);
    this.code = code;
    this.params = params;
    this.fieldErrors = fieldErrors;
    this.detail = detail;
    this.traceId = traceId;
    this.status = status;
  }
  static from(body, status) {
    const b = body ?? {};
    const detail = Array.isArray(b.message) ? b.message.join(", ") : b.message;
    return new _ApiError(
      b.code ?? "system.internal",
      b.params ?? {},
      b.fieldErrors,
      detail,
      b.traceId,
      status
    );
  }
};
function interpolate(template, params, currency) {
  return template.replace(/\{\{(\w+)\}\}/g, (_, k) => {
    const v = params[k];
    if (v == null) return "";
    if (currency && typeof v === "number" && /Cents$/.test(k)) return formatMoney(v, currency);
    return String(v);
  });
}
function errorMessage(body, messages, currency) {
  const template = messages[body.code] ?? messages["system.internal"] ?? "Something went wrong.";
  return interpolate(template, body.params ?? {}, currency);
}
function unwrap(result) {
  if (result.status >= 400) {
    throw ApiError.from(result.body, result.status);
  }
  return result.body;
}

// src/error-messages/en.ts
var EN = {
  "order.slotFull": "That time just filled up. Next available: {{slot}}.",
  "order.belowMinOrder": "Minimum order is {{minCents}}. Add {{shortfallCents}} more.",
  "order.leadTimeViolation": "Order at least {{minutes}} minutes ahead.",
  "order.outsideDeliveryZone": "Sorry, we don't deliver to your area.",
  "order.deliveryFeeUnavailable": "We can't calculate the delivery fee right now. Please try again in a moment.",
  "order.prepAlreadyStarted": "Too late to cancel \u2014 the kitchen already started.",
  "order.paymentNotReady": "Can't accept yet \u2014 the customer hasn't completed payment.",
  // The one error string the dashboard renders on a success path — a toast, not
  // a dialog, since the accept already happened (see AcceptOrderSheet).
  "order.alreadyConfirmed": "That order has already been accepted.",
  "order.alreadyCancelled": "This order was cancelled, so it can no longer be accepted.",
  "order.itemOutOfStock": "{{name}} just went out of stock.",
  "order.orderingPaused": "{{orderType}} paused until {{until}}.",
  "order.orderTypeUnavailable": "This order type isn't available right now.",
  "order.cashPaymentUnavailable": "Cash payment isn't available right now.",
  "order.cardPaymentUnavailable": "Card payment isn't available for this order type.",
  "order.cardOnHandoffUnavailable": "Paying by card at handoff isn't available for this order type.",
  "order.paymentMethodRequired": "Please choose a payment method.",
  "order.promotionInvalid": "The selected promotion is no longer valid. Please review your discounts.",
  "order.restaurantClosed": "The restaurant isn't accepting orders right now.",
  "order.cartItemUnavailable": "An item in your cart is no longer available. Please refresh and try again.",
  "order.optionSelectionInvalid": "\u201C{{product}}\u201D: the choices for {{option}} don't match what the restaurant allows. Please edit the item.",
  "order.itemNotAvailableAtTime": "\u201C{{product}}\u201D is not available at the selected time. Please pick a time within its hours.",
  "order.deliveryAddressRequired": "A delivery address is required.",
  "order.deliveryAddressUnlocatable": "We couldn't locate that address. Please check it and try again.",
  "menu.noActiveMenu": "This restaurant isn't taking orders online right now.",
  "menu.optionLimitOutOfRange": "\u201C{{option}}\u201D has {{choices}} choices. Set the minimum from 0 to {{choices}} and the maximum from 1 to {{choices}}, with the minimum not above the maximum.",
  "menu.productCodeTaken": "That product code is already used by another item in this menu.",
  "customer.invalidPhone": "That phone number isn't valid \u2014 enter a reachable number with the area code.",
  "payment.refundExceedsRemaining": "Refund exceeds the {{remainingCents}} still refundable.",
  "payment.voidNoRefund": "This payment was voided \u2014 nothing to refund.",
  "payment.onlineRefundUnsupported": "Refunds for this online payment are handled outside the app.",
  "payment.providerUnavailable": "Card payment isn't available right now. Please choose another payment method.",
  "payment.providerAuthFailed": "The payment provider rejected these credentials. Check the keys, and that Test/Live matches the keys you pasted.",
  "payment.providerUnreachable": "Couldn't reach the payment provider. Try again in a moment.",
  "payment.providerHostModeMismatch": "This service URL doesn't match the selected Test/Live mode. Test keys need the test host, Live keys need the live host.",
  "payment.encryptionNotConfigured": "Online payments aren't set up on this server yet. Contact support.",
  "reservation.shiftOverlap": 'This shift overlaps "{{label}}" ({{startTime}}\u2013{{endTime}}) on a shared day. Adjust the time or days.',
  "reservation.slotTooLate": "That time is now too close to book \u2014 bookings close {{cutoffMinutes}} minutes ahead. Please pick a later time.",
  "reservation.slotInPast": "That time has already passed. Please pick a later time.",
  "reservation.slotUnavailable": "That time just filled up. Please pick another time.",
  "reservation.bookingsPaused": "Online bookings are paused until {{until}}. Please pick a later time or contact the restaurant.",
  "reservation.notEditable": "This reservation can no longer be edited because it was cancelled, rejected, or already completed.",
  "reservation.statusChanged": "This reservation was just changed by someone else. Check its current status and try again.",
  "openingHours.exceptionOverlap": "This date range already has an exception for one of the selected services. Adjust the dates or services.",
  "openingHours.shiftsOverlap": "Two time ranges on the same day overlap. Adjust them so they do not intersect.",
  "openingHours.shiftTimesEqual": "Opening and closing time cannot be the same.",
  "openingHours.invalidTimeFormat": "\u201C{{time}}\u201D is not a valid time. Use HH:mm.",
  "system.validationFailed": "Please check the highlighted fields.",
  "system.unauthenticated": "Please sign in again.",
  "system.forbidden": "You don't have permission to do this.",
  "system.notFound": "We couldn't find what you were looking for.",
  "system.conflict": "That can't be done in the current state.",
  "promotion.couponAlreadyIssued": "This customer already has a coupon for this promotion.",
  "promotion.codeInUse": 'The code "{{code}}" is already in use.',
  "print.noPrinterConfigured": "No printer is set up to print this ticket.",
  "print.notPrintable": "This order type has no kitchen ticket.",
  "system.badRequest": "We couldn't process that request.",
  "system.internal": "Something went wrong. Please try again.",
  "worker.notFound": "Staff member not found.",
  "worker.notAssigned": "That staff member isn't assigned here.",
  "worker.alreadyAssigned": "That person already works at this restaurant.",
  "worker.emailTaken": "An account with this email already exists.",
  "worker.lastManager": "This is the only manager \u2014 assign another first.",
  "worker.selfRoleChange": "You can't change your own role.",
  "worker.selfDeactivate": "You can't deactivate your own account.",
  "partner.selfRoleChange": "You can't change your own group role.",
  "partner.selfRemove": "You can't remove yourself from the group.",
  "partner.lastGroupAdmin": "This is the group's only admin - make someone else admin first.",
  "partner.memberInactive": "This member was removed. Invite them again instead.",
  "partner.memberChanged": "Someone else just changed this member. Reload and try again.",
  "worker.lastOwner": "This is the only owner - make someone else owner first.",
  "user.emailTaken": "An account with this email already exists.",
  "user.selfRevokeAdmin": "You can't remove your own system admin role.",
  "user.lastSystemAdmin": "This is the only system admin - make someone else system admin first.",
  "label.systemOwned": "\u201C{{name}}\u201D is a built-in label and can't be deleted. Rename it instead.",
  "label.inUseByRule": "\u201C{{name}}\u201D is used by a purge rule. Remove it from the rule first, or delete the rule.",
  "purge.previewOutdated": "The list changed since you checked it: {{expected}} then, {{actual}} now. Nothing was hidden. Check it again before hiding."
};

// src/error-messages/de.ts
var DE = {
  "order.slotFull": "Dieser Zeitslot ist gerade ausgebucht. N\xE4chster verf\xFCgbarer: {{slot}}.",
  "order.belowMinOrder": "Mindestbestellwert ist {{minCents}}. F\xFCge noch {{shortfallCents}} hinzu.",
  "order.leadTimeViolation": "Bitte {{minutes}} Minuten im Voraus bestellen.",
  "order.outsideDeliveryZone": "Entschuldigung, in deine Region liefern wir leider nicht.",
  "order.deliveryFeeUnavailable": "Die Liefergeb\xFChr kann gerade nicht berechnet werden. Bitte versuche es gleich noch einmal.",
  "order.prepAlreadyStarted": "Stornierung nicht mehr m\xF6glich \u2014 die K\xFCche hat bereits begonnen.",
  "order.paymentNotReady": "Annahme noch nicht m\xF6glich \u2014 der Kunde hat die Zahlung noch nicht abgeschlossen.",
  "order.alreadyConfirmed": "Diese Bestellung wurde bereits angenommen.",
  "order.alreadyCancelled": "Diese Bestellung wurde storniert und kann nicht mehr angenommen werden.",
  "order.itemOutOfStock": "{{name}} ist leider gerade ausverkauft.",
  "order.orderingPaused": "{{orderType}} pausiert bis {{until}}.",
  "order.orderTypeUnavailable": "Diese Bestellart ist derzeit nicht verf\xFCgbar.",
  "order.cashPaymentUnavailable": "Barzahlung ist derzeit nicht verf\xFCgbar.",
  "order.cardPaymentUnavailable": "Kartenzahlung ist f\xFCr diese Bestellart nicht verf\xFCgbar.",
  "order.cardOnHandoffUnavailable": "Kartenzahlung bei \xDCbergabe ist f\xFCr diese Bestellart nicht verf\xFCgbar.",
  "order.paymentMethodRequired": "Bitte w\xE4hle eine Zahlungsart.",
  "order.promotionInvalid": "Die gew\xE4hlte Aktion ist nicht mehr g\xFCltig. Bitte pr\xFCfe deine Rabatte.",
  "order.restaurantClosed": "Das Restaurant nimmt derzeit keine Bestellungen an.",
  "order.cartItemUnavailable": "Ein Artikel in deinem Warenkorb ist nicht mehr verf\xFCgbar. Bitte aktualisiere die Seite.",
  "order.optionSelectionInvalid": "\u201E{{product}}\u201C: Die Auswahl bei {{option}} passt nicht zu den Vorgaben des Restaurants. Bitte bearbeite den Artikel.",
  "order.itemNotAvailableAtTime": "\u201E{{product}}\u201C ist zur gew\xE4hlten Zeit nicht verf\xFCgbar. Bitte w\xE4hle eine Zeit innerhalb der Verf\xFCgbarkeit.",
  "order.deliveryAddressRequired": "Eine Lieferadresse ist erforderlich.",
  "order.deliveryAddressUnlocatable": "Wir konnten diese Adresse nicht finden. Bitte \xFCberpr\xFCfe sie und versuche es erneut.",
  "menu.noActiveMenu": "Dieses Restaurant nimmt derzeit keine Online-Bestellungen an.",
  "menu.optionLimitOutOfRange": "\u201E{{option}}\u201C hat {{choices}} Auswahlm\xF6glichkeiten. Das Minimum muss zwischen 0 und {{choices}} liegen, das Maximum zwischen 1 und {{choices}}, und das Minimum darf nicht \xFCber dem Maximum liegen.",
  "menu.productCodeTaken": "Dieser Artikelcode wird bereits von einem anderen Artikel in dieser Speisekarte verwendet.",
  "customer.invalidPhone": "Diese Telefonnummer ist ung\xFCltig \u2013 bitte eine erreichbare Nummer mit Vorwahl eingeben.",
  "payment.refundExceedsRemaining": "Erstattung \xFCbersteigt den verbleibenden Betrag von {{remainingCents}}.",
  "payment.voidNoRefund": "Diese Zahlung wurde storniert \u2014 keine Erstattung m\xF6glich.",
  "payment.onlineRefundUnsupported": "Erstattungen f\xFCr diese Online-Zahlung werden au\xDFerhalb der App abgewickelt.",
  "payment.providerUnavailable": "Kartenzahlung ist derzeit nicht m\xF6glich. Bitte w\xE4hlen Sie eine andere Zahlungsart.",
  "payment.providerAuthFailed": "Der Zahlungsanbieter hat diese Zugangsdaten abgelehnt. Pr\xFCfe die Schl\xFCssel und ob Test/Live zu den eingef\xFCgten Schl\xFCsseln passt.",
  "payment.providerUnreachable": "Der Zahlungsanbieter war nicht erreichbar. Bitte versuche es gleich noch einmal.",
  "payment.providerHostModeMismatch": "Diese Service-URL passt nicht zum gew\xE4hlten Modus (Test/Live). Test-Schl\xFCssel brauchen den Test-Host, Live-Schl\xFCssel den Live-Host.",
  "payment.encryptionNotConfigured": "Online-Zahlungen sind auf diesem Server noch nicht eingerichtet. Bitte wende dich an den Support.",
  "reservation.shiftOverlap": 'Diese Schicht \xFCberschneidet sich mit \u201E{{label}}" ({{startTime}}\u2013{{endTime}}) an einem gemeinsamen Tag. Passe Zeit oder Tage an.',
  "reservation.slotTooLate": "Diese Uhrzeit liegt jetzt zu kurzfristig \u2014 Buchungen schlie\xDFen {{cutoffMinutes}} Minuten vorher. Bitte w\xE4hle eine sp\xE4tere Uhrzeit.",
  "reservation.slotInPast": "Diese Uhrzeit ist bereits vergangen. Bitte w\xE4hle eine sp\xE4tere Uhrzeit.",
  "reservation.slotUnavailable": "Diese Uhrzeit ist gerade ausgebucht. Bitte w\xE4hle eine andere Uhrzeit.",
  "reservation.bookingsPaused": "Online-Buchungen sind bis {{until}} pausiert. Bitte w\xE4hle eine sp\xE4tere Uhrzeit oder wende dich an das Restaurant.",
  "reservation.notEditable": "Diese Reservierung kann nicht mehr bearbeitet werden, da sie storniert, abgelehnt oder bereits abgeschlossen wurde.",
  "reservation.statusChanged": "Diese Reservierung wurde gerade von jemand anderem ge\xE4ndert. Pr\xFCfe den aktuellen Status und versuche es erneut.",
  "openingHours.exceptionOverlap": "F\xFCr diesen Zeitraum besteht bereits eine Ausnahme f\xFCr einen der gew\xE4hlten Dienste. Passe die Daten oder Dienste an.",
  "openingHours.shiftsOverlap": "Zwei Zeitr\xE4ume am selben Tag \xFCberschneiden sich. Passe sie so an, dass sie sich nicht \xFCberlappen.",
  "openingHours.shiftTimesEqual": "\xD6ffnungs- und Schlie\xDFzeit d\xFCrfen nicht gleich sein.",
  "openingHours.invalidTimeFormat": "\u201E{{time}}\u201C ist keine g\xFCltige Uhrzeit. Verwende HH:mm.",
  "system.validationFailed": "Bitte pr\xFCfe die markierten Felder.",
  "system.unauthenticated": "Bitte melde dich erneut an.",
  "system.forbidden": "Du hast keine Berechtigung daf\xFCr.",
  "system.notFound": "Das Gesuchte konnte nicht gefunden werden.",
  "system.conflict": "Das ist im aktuellen Zustand nicht m\xF6glich.",
  "promotion.couponAlreadyIssued": "Dieser Kunde hat bereits einen Gutschein f\xFCr diese Aktion.",
  "promotion.codeInUse": 'Der Code \u201E{{code}}" wird bereits verwendet.',
  "print.noPrinterConfigured": "F\xFCr diesen Bon ist kein Drucker eingerichtet.",
  "print.notPrintable": "F\xFCr diese Bestellart gibt es keinen K\xFCchenbon.",
  "system.badRequest": "Diese Anfrage konnte nicht verarbeitet werden.",
  "system.internal": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "worker.notFound": "Mitarbeiter nicht gefunden.",
  "worker.notAssigned": "Dieser Mitarbeiter ist hier nicht zugewiesen.",
  "worker.alreadyAssigned": "Diese Person arbeitet bereits in diesem Restaurant.",
  "worker.emailTaken": "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",
  "worker.lastManager": "Das ist der einzige Manager \u2014 weise zuerst einen anderen zu.",
  "worker.selfRoleChange": "Du kannst deine eigene Rolle nicht \xE4ndern.",
  "worker.selfDeactivate": "Du kannst dein eigenes Konto nicht deaktivieren.",
  "partner.selfRoleChange": "Du kannst deine eigene Gruppenrolle nicht \xE4ndern.",
  "partner.selfRemove": "Du kannst dich nicht selbst aus der Gruppe entfernen.",
  "partner.lastGroupAdmin": "Das ist der einzige Admin der Gruppe - ernenne zuerst einen anderen.",
  "partner.memberInactive": "Dieses Mitglied wurde entfernt. Lade es stattdessen erneut ein.",
  "partner.memberChanged": "Jemand anderes hat dieses Mitglied gerade ge\xE4ndert. Lade neu und versuche es erneut.",
  "worker.lastOwner": "Das ist der einzige Inhaber - ernenne zuerst einen anderen.",
  "user.emailTaken": "Es gibt bereits ein Konto mit dieser E-Mail.",
  "user.selfRevokeAdmin": "Du kannst dir die Systemadmin-Rolle nicht selbst entziehen.",
  "user.lastSystemAdmin": "Das ist der einzige Systemadmin - ernenne zuerst einen anderen.",
  "label.systemOwned": "\u201E{{name}}\u201C ist ein integriertes Label und kann nicht gel\xF6scht werden. Benenne es stattdessen um.",
  "label.inUseByRule": "\u201E{{name}}\u201C wird von einer L\xF6schregel verwendet. Entferne es zuerst aus der Regel oder l\xF6sche die Regel.",
  "purge.previewOutdated": "Die Liste hat sich seit der Vorschau ge\xE4ndert: vorher {{expected}}, jetzt {{actual}}. Es wurde nichts ausgeblendet. Pr\xFCfe sie erneut, bevor du ausblendest."
};

// src/error-messages/pl.ts
var PL = {
  "order.slotFull": "Ten termin w\u0142a\u015Bnie si\u0119 zape\u0142ni\u0142. Najbli\u017Cszy dost\u0119pny: {{slot}}.",
  "order.belowMinOrder": "Minimalna warto\u015B\u0107 zam\xF3wienia to {{minCents}}. Dodaj jeszcze {{shortfallCents}}.",
  "order.leadTimeViolation": "Z\u0142\xF3\u017C zam\xF3wienie z co najmniej {{minutes}} minutowym wyprzedzeniem.",
  "order.outsideDeliveryZone": "Przepraszamy, nie dowozimy do Twojej okolicy.",
  "order.deliveryFeeUnavailable": "Nie mo\u017Cemy teraz obliczy\u0107 kosztu dostawy. Spr\xF3buj ponownie za chwil\u0119.",
  "order.prepAlreadyStarted": "Za p\xF3\u017Ano na anulowanie \u2014 kuchnia ju\u017C zacz\u0119\u0142a przygotowanie.",
  "order.paymentNotReady": "Nie mo\u017Cna jeszcze przyj\u0105\u0107 \u2014 klient nie uko\u0144czy\u0142 p\u0142atno\u015Bci.",
  "order.alreadyConfirmed": "To zam\xF3wienie zosta\u0142o ju\u017C przyj\u0119te.",
  "order.alreadyCancelled": "To zam\xF3wienie zosta\u0142o anulowane i nie mo\u017Cna go ju\u017C przyj\u0105\u0107.",
  "order.itemOutOfStock": "{{name}} w\u0142a\u015Bnie si\u0119 sko\u0144czy\u0142.",
  "order.orderingPaused": "{{orderType}} wstrzymane do {{until}}.",
  "order.orderTypeUnavailable": "Ten spos\xF3b zamawiania jest obecnie niedost\u0119pny.",
  "order.cashPaymentUnavailable": "P\u0142atno\u015B\u0107 got\xF3wk\u0105 jest obecnie niedost\u0119pna.",
  "order.cardPaymentUnavailable": "P\u0142atno\u015B\u0107 kart\u0105 jest niedost\u0119pna dla tego sposobu zamawiania.",
  "order.cardOnHandoffUnavailable": "P\u0142atno\u015B\u0107 kart\u0105 przy odbiorze jest niedost\u0119pna dla tego sposobu zamawiania.",
  "order.paymentMethodRequired": "Wybierz metod\u0119 p\u0142atno\u015Bci.",
  "order.promotionInvalid": "Wybrana promocja nie jest ju\u017C wa\u017Cna. Sprawd\u017A swoje rabaty.",
  "order.restaurantClosed": "Restauracja obecnie nie przyjmuje zam\xF3wie\u0144.",
  "order.cartItemUnavailable": "Pozycja w koszyku nie jest ju\u017C dost\u0119pna. Od\u015Bwie\u017C stron\u0119 i spr\xF3buj ponownie.",
  "order.optionSelectionInvalid": "\u201E{{product}}\u201D: wyb\xF3r w {{option}} nie zgadza si\u0119 z zasadami restauracji. Edytuj pozycj\u0119.",
  "order.itemNotAvailableAtTime": "\u201E{{product}}\u201D nie jest dost\u0119pne w wybranym czasie. Wybierz godzin\u0119 w jego dost\u0119pno\u015Bci.",
  "order.deliveryAddressRequired": "Wymagany jest adres dostawy.",
  "order.deliveryAddressUnlocatable": "Nie mogli\u015Bmy zlokalizowa\u0107 tego adresu. Sprawd\u017A go i spr\xF3buj ponownie.",
  "menu.noActiveMenu": "Ta restauracja obecnie nie przyjmuje zam\xF3wie\u0144 online.",
  "menu.optionLimitOutOfRange": "\u201E{{option}}\u201D ma {{choices}} opcji. Minimum musi wynosi\u0107 od 0 do {{choices}}, maksimum od 1 do {{choices}}, a minimum nie mo\u017Ce by\u0107 wi\u0119ksze ni\u017C maksimum.",
  "menu.productCodeTaken": "Ten kod produktu jest ju\u017C u\u017Cywany przez inn\u0105 pozycj\u0119 w tym menu.",
  "customer.invalidPhone": "Ten numer telefonu jest nieprawid\u0142owy \u2013 podaj numer z numerem kierunkowym.",
  "payment.refundExceedsRemaining": "Zwrot przekracza pozosta\u0142\u0105 kwot\u0119 do zwrotu wynosz\u0105c\u0105 {{remainingCents}}.",
  "payment.voidNoRefund": "Ta p\u0142atno\u015B\u0107 zosta\u0142a anulowana \u2014 nie ma czego zwraca\u0107.",
  "payment.onlineRefundUnsupported": "Zwroty za t\u0119 p\u0142atno\u015B\u0107 online s\u0105 obs\u0142ugiwane poza aplikacj\u0105.",
  "payment.providerUnavailable": "P\u0142atno\u015B\u0107 kart\u0105 jest teraz niedost\u0119pna. Wybierz inn\u0105 metod\u0119 p\u0142atno\u015Bci.",
  "payment.providerAuthFailed": "Dostawca p\u0142atno\u015Bci odrzuci\u0142 te dane. Sprawd\u017A klucze oraz czy tryb Test/Live pasuje do wklejonych kluczy.",
  "payment.providerUnreachable": "Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107 z dostawc\u0105 p\u0142atno\u015Bci. Spr\xF3buj ponownie za chwil\u0119.",
  "payment.providerHostModeMismatch": "Ten adres us\u0142ugi nie pasuje do wybranego trybu Test/Live. Klucze testowe wymagaj\u0105 hosta testowego, a klucze Live \u2014 hosta produkcyjnego.",
  "payment.encryptionNotConfigured": "P\u0142atno\u015Bci online nie s\u0105 jeszcze skonfigurowane na tym serwerze. Skontaktuj si\u0119 z pomoc\u0105 techniczn\u0105.",
  "reservation.shiftOverlap": 'Ta zmiana pokrywa si\u0119 z \u201E{{label}}" ({{startTime}}\u2013{{endTime}}) w tym samym dniu. Zmie\u0144 godzin\u0119 lub dni.',
  "reservation.slotTooLate": "Ta godzina jest ju\u017C zbyt bliska \u2014 rezerwacje zamykaj\u0105 si\u0119 {{cutoffMinutes}} minut wcze\u015Bniej. Wybierz p\xF3\u017Aniejsz\u0105 godzin\u0119.",
  "reservation.slotInPast": "Ta godzina ju\u017C min\u0119\u0142a. Wybierz p\xF3\u017Aniejsz\u0105 godzin\u0119.",
  "reservation.slotUnavailable": "Ta godzina w\u0142a\u015Bnie si\u0119 zape\u0142ni\u0142a. Wybierz inn\u0105 godzin\u0119.",
  "reservation.bookingsPaused": "Rezerwacje online s\u0105 wstrzymane do {{until}}. Wybierz p\xF3\u017Aniejsz\u0105 godzin\u0119 lub skontaktuj si\u0119 z restauracj\u0105.",
  "reservation.notEditable": "Tej rezerwacji nie mo\u017Cna ju\u017C edytowa\u0107, poniewa\u017C zosta\u0142a anulowana, odrzucona lub ju\u017C zako\u0144czona.",
  "reservation.statusChanged": "Ta rezerwacja zosta\u0142a w\u0142a\u015Bnie zmieniona przez kogo\u015B innego. Sprawd\u017A jej aktualny status i spr\xF3buj ponownie.",
  "openingHours.exceptionOverlap": "Ten zakres dat ma ju\u017C wyj\u0105tek dla jednej z wybranych us\u0142ug. Zmie\u0144 daty lub us\u0142ugi.",
  "openingHours.shiftsOverlap": "Dwa zakresy godzin tego samego dnia nak\u0142adaj\u0105 si\u0119. Zmie\u0144 je tak, aby si\u0119 nie pokrywa\u0142y.",
  "openingHours.shiftTimesEqual": "Godzina otwarcia i zamkni\u0119cia nie mog\u0105 by\u0107 takie same.",
  "openingHours.invalidTimeFormat": "\u201E{{time}}\u201D to nieprawid\u0142owa godzina. U\u017Cyj formatu HH:mm.",
  "system.validationFailed": "Sprawd\u017A zaznaczone pola.",
  "system.unauthenticated": "Zaloguj si\u0119 ponownie.",
  "system.forbidden": "Nie masz uprawnie\u0144, aby to zrobi\u0107.",
  "system.notFound": "Nie uda\u0142o si\u0119 znale\u017A\u0107 tego, czego szukasz.",
  "system.conflict": "Nie mo\u017Cna tego zrobi\u0107 w obecnym stanie.",
  "promotion.couponAlreadyIssued": "Ten klient ma ju\u017C kupon do tej promocji.",
  "promotion.codeInUse": 'Kod \u201E{{code}}" jest ju\u017C u\u017Cywany.',
  "print.noPrinterConfigured": "Nie skonfigurowano drukarki dla tego bonu.",
  "print.notPrintable": "Ten typ zam\xF3wienia nie ma bonu kuchennego.",
  "system.badRequest": "Nie uda\u0142o si\u0119 przetworzy\u0107 tego \u017C\u0105dania.",
  "system.internal": "Co\u015B posz\u0142o nie tak. Spr\xF3buj ponownie.",
  "worker.notFound": "Nie znaleziono pracownika.",
  "worker.notAssigned": "Ten pracownik nie jest tu przypisany.",
  "worker.alreadyAssigned": "Ta osoba ju\u017C pracuje w tej restauracji.",
  "worker.emailTaken": "Konto z tym adresem e-mail ju\u017C istnieje.",
  "worker.lastManager": "To jedyny mened\u017Cer \u2014 najpierw przypisz innego.",
  "worker.selfRoleChange": "Nie mo\u017Cesz zmieni\u0107 w\u0142asnej roli.",
  "worker.selfDeactivate": "Nie mo\u017Cesz dezaktywowa\u0107 w\u0142asnego konta.",
  "partner.selfRoleChange": "Nie mo\u017Cesz zmieni\u0107 w\u0142asnej roli w grupie.",
  "partner.selfRemove": "Nie mo\u017Cesz usun\u0105\u0107 siebie z grupy.",
  "partner.lastGroupAdmin": "To jedyny administrator grupy - najpierw wyznacz innego.",
  "partner.memberInactive": "Ten cz\u0142onek zosta\u0142 usuni\u0119ty. Zapro\u015B go ponownie.",
  "partner.memberChanged": "Kto\u015B inny w\u0142a\u015Bnie zmieni\u0142 tego cz\u0142onka. Od\u015Bwie\u017C i spr\xF3buj ponownie.",
  "worker.lastOwner": "To jedyny w\u0142a\u015Bciciel - najpierw wyznacz innego.",
  "user.emailTaken": "Konto z tym adresem e-mail ju\u017C istnieje.",
  "user.selfRevokeAdmin": "Nie mo\u017Cesz odebra\u0107 sobie roli administratora systemu.",
  "user.lastSystemAdmin": "To jedyny administrator systemu - najpierw wyznacz innego.",
  "label.systemOwned": "Etykieta \u201E{{name}}\u201D jest wbudowana i nie mo\u017Cna jej usun\u0105\u0107. Zmie\u0144 jej nazw\u0119.",
  "label.inUseByRule": "Etykieta \u201E{{name}}\u201D jest u\u017Cywana przez regu\u0142\u0119 czyszczenia. Najpierw usu\u0144 j\u0105 z regu\u0142y lub usu\u0144 regu\u0142\u0119.",
  "purge.previewOutdated": "Lista zmieni\u0142a si\u0119 od podgl\u0105du: wcze\u015Bniej {{expected}}, teraz {{actual}}. Nic nie zosta\u0142o ukryte. Sprawd\u017A j\u0105 ponownie przed ukryciem."
};

// src/error-messages/vi.ts
var VI = {
  "order.slotFull": "Khung gi\u1EDD n\xE0y v\u1EEBa h\u1EBFt ch\u1ED7. Gi\u1EDD ti\u1EBFp theo: {{slot}}.",
  "order.belowMinOrder": "\u0110\u01A1n t\u1ED1i thi\u1EC3u l\xE0 {{minCents}}. Th\xEAm {{shortfallCents}} n\u1EEFa.",
  "order.leadTimeViolation": "Vui l\xF2ng \u0111\u1EB7t tr\u01B0\u1EDBc \xEDt nh\u1EA5t {{minutes}} ph\xFAt.",
  "order.outsideDeliveryZone": "R\u1EA5t ti\u1EBFc, ch\xFAng t\xF4i kh\xF4ng giao h\xE0ng \u0111\u1EBFn khu v\u1EF1c c\u1EE7a b\u1EA1n.",
  "order.deliveryFeeUnavailable": "Hi\u1EC7n ch\u01B0a t\xEDnh \u0111\u01B0\u1EE3c ph\xED giao h\xE0ng. Vui l\xF2ng th\u1EED l\u1EA1i trong gi\xE2y l\xE1t.",
  "order.prepAlreadyStarted": "Qu\xE1 mu\u1ED9n \u0111\u1EC3 h\u1EE7y \u2014 nh\xE0 b\u1EBFp \u0111\xE3 b\u1EAFt \u0111\u1EA7u ch\u1EBF bi\u1EBFn.",
  "order.paymentNotReady": "Ch\u01B0a th\u1EC3 nh\u1EADn \u0111\u01A1n \u2014 kh\xE1ch ch\u01B0a ho\xE0n t\u1EA5t thanh to\xE1n.",
  "order.alreadyConfirmed": "\u0110\u01A1n h\xE0ng n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c nh\u1EADn r\u1ED3i.",
  "order.alreadyCancelled": "\u0110\u01A1n h\xE0ng n\xE0y \u0111\xE3 b\u1ECB h\u1EE7y n\xEAn kh\xF4ng th\u1EC3 nh\u1EADn n\u1EEFa.",
  "order.itemOutOfStock": "{{name}} v\u1EEBa h\u1EBFt h\xE0ng.",
  "order.orderingPaused": "{{orderType}} t\u1EA1m d\u1EEBng \u0111\u1EBFn {{until}}.",
  "order.orderTypeUnavailable": "H\xECnh th\u1EE9c \u0111\u1EB7t n\xE0y hi\u1EC7n kh\xF4ng kh\u1EA3 d\u1EE5ng.",
  "order.cashPaymentUnavailable": "Thanh to\xE1n ti\u1EC1n m\u1EB7t hi\u1EC7n kh\xF4ng kh\u1EA3 d\u1EE5ng.",
  "order.cardPaymentUnavailable": "Thanh to\xE1n th\u1EBB kh\xF4ng kh\u1EA3 d\u1EE5ng cho h\xECnh th\u1EE9c \u0111\u1EB7t n\xE0y.",
  "order.cardOnHandoffUnavailable": "Thanh to\xE1n th\u1EBB khi nh\u1EADn kh\xF4ng kh\u1EA3 d\u1EE5ng cho h\xECnh th\u1EE9c \u0111\u1EB7t n\xE0y.",
  "order.paymentMethodRequired": "Vui l\xF2ng ch\u1ECDn ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n.",
  "order.promotionInvalid": "Khuy\u1EBFn m\xE3i \u0111\xE3 ch\u1ECDn kh\xF4ng c\xF2n h\u1EE3p l\u1EC7. Vui l\xF2ng ki\u1EC3m tra l\u1EA1i \u01B0u \u0111\xE3i.",
  "order.restaurantClosed": "Nh\xE0 h\xE0ng hi\u1EC7n kh\xF4ng nh\u1EADn \u0111\u01A1n.",
  "order.cartItemUnavailable": "M\u1ED9t m\xF3n trong gi\u1ECF h\xE0ng kh\xF4ng c\xF2n kh\u1EA3 d\u1EE5ng. Vui l\xF2ng t\u1EA3i l\u1EA1i v\xE0 th\u1EED l\u1EA1i.",
  "order.optionSelectionInvalid": "\u201C{{product}}\u201D: l\u1EF1a ch\u1ECDn \u1EDF {{option}} kh\xF4ng kh\u1EDBp quy \u0111\u1ECBnh c\u1EE7a nh\xE0 h\xE0ng. Vui l\xF2ng s\u1EEDa m\xF3n.",
  "order.itemNotAvailableAtTime": "\u201C{{product}}\u201D kh\xF4ng c\xF3 s\u1EB5n v\xE0o th\u1EDDi gian \u0111\xE3 ch\u1ECDn. Vui l\xF2ng ch\u1ECDn gi\u1EDD trong khung ph\u1EE5c v\u1EE5.",
  "order.deliveryAddressRequired": "C\u1EA7n c\xF3 \u0111\u1ECBa ch\u1EC9 giao h\xE0ng.",
  "order.deliveryAddressUnlocatable": "Kh\xF4ng \u0111\u1ECBnh v\u1ECB \u0111\u01B0\u1EE3c \u0111\u1ECBa ch\u1EC9 n\xE0y. Vui l\xF2ng ki\u1EC3m tra l\u1EA1i v\xE0 th\u1EED l\u1EA1i.",
  "menu.noActiveMenu": "Nh\xE0 h\xE0ng n\xE0y hi\u1EC7n ch\u01B0a nh\u1EADn \u0111\u1EB7t m\xF3n tr\u1EF1c tuy\u1EBFn.",
  "menu.optionLimitOutOfRange": "\u201C{{option}}\u201D c\xF3 {{choices}} l\u1EF1a ch\u1ECDn. T\u1ED1i thi\u1EC3u ph\u1EA3i t\u1EEB 0 \u0111\u1EBFn {{choices}}, t\u1ED1i \u0111a t\u1EEB 1 \u0111\u1EBFn {{choices}}, v\xE0 t\u1ED1i thi\u1EC3u kh\xF4ng l\u1EDBn h\u01A1n t\u1ED1i \u0111a.",
  "menu.productCodeTaken": "M\xE3 m\xF3n n\xE0y \u0111\xE3 \u0111\u01B0\u1EE3c d\xF9ng cho m\u1ED9t m\xF3n kh\xE1c trong th\u1EF1c \u0111\u01A1n n\xE0y.",
  "customer.invalidPhone": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7 \u2014 nh\u1EADp s\u1ED1 li\xEAn h\u1EC7 \u0111\u01B0\u1EE3c, k\xE8m m\xE3 v\xF9ng.",
  "payment.refundExceedsRemaining": "Ho\xE0n ti\u1EC1n v\u01B0\u1EE3t qu\xE1 s\u1ED1 ti\u1EC1n c\xF2n l\u1EA1i {{remainingCents}}.",
  "payment.voidNoRefund": "Thanh to\xE1n n\xE0y \u0111\xE3 b\u1ECB h\u1EE7y \u2014 kh\xF4ng th\u1EC3 ho\xE0n ti\u1EC1n.",
  "payment.onlineRefundUnsupported": "Ho\xE0n ti\u1EC1n cho thanh to\xE1n tr\u1EF1c tuy\u1EBFn n\xE0y \u0111\u01B0\u1EE3c x\u1EED l\xFD b\xEAn ngo\xE0i \u1EE9ng d\u1EE5ng.",
  "payment.providerUnavailable": "Thanh to\xE1n th\u1EBB hi\u1EC7n kh\xF4ng kh\u1EA3 d\u1EE5ng. Vui l\xF2ng ch\u1ECDn ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n kh\xE1c.",
  "payment.providerAuthFailed": "Nh\xE0 cung c\u1EA5p thanh to\xE1n \u0111\xE3 t\u1EEB ch\u1ED1i th\xF4ng tin n\xE0y. Ki\u1EC3m tra l\u1EA1i kh\xF3a, v\xE0 ch\u1EAFc ch\u1EAFn ch\u1EBF \u0111\u1ED9 Test/Live kh\u1EDBp v\u1EDBi kh\xF3a b\u1EA1n \u0111\xE3 d\xE1n.",
  "payment.providerUnreachable": "Kh\xF4ng k\u1EBFt n\u1ED1i \u0111\u01B0\u1EE3c v\u1EDBi nh\xE0 cung c\u1EA5p thanh to\xE1n. Vui l\xF2ng th\u1EED l\u1EA1i trong gi\xE2y l\xE1t.",
  "payment.providerHostModeMismatch": "Service URL n\xE0y kh\xF4ng kh\u1EDBp v\u1EDBi ch\u1EBF \u0111\u1ED9 Test/Live \u0111ang ch\u1ECDn. Kh\xF3a Test c\u1EA7n host th\u1EED nghi\u1EC7m, kh\xF3a Live c\u1EA7n host ch\xEDnh th\u1EE9c.",
  "payment.encryptionNotConfigured": "M\xE1y ch\u1EE7 n\xE0y ch\u01B0a thi\u1EBFt l\u1EADp thanh to\xE1n tr\u1EF1c tuy\u1EBFn. Vui l\xF2ng li\xEAn h\u1EC7 b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3.",
  "reservation.shiftOverlap": 'Ca n\xE0y tr\xF9ng gi\u1EDD v\u1EDBi "{{label}}" ({{startTime}}\u2013{{endTime}}) v\xE0o ng\xE0y chung. \u0110\u1ED5i gi\u1EDD ho\u1EB7c ng\xE0y \u0111\u1EC3 kh\xF4ng b\u1ECB ch\u1ED3ng.',
  "reservation.slotTooLate": "Gi\u1EDD n\xE0y \u0111\xE3 qu\xE1 s\xE1t \u2014 nh\xE0 h\xE0ng ng\u1EEBng nh\u1EADn \u0111\u1EB7t b\xE0n tr\u01B0\u1EDBc {{cutoffMinutes}} ph\xFAt. Vui l\xF2ng ch\u1ECDn gi\u1EDD mu\u1ED9n h\u01A1n.",
  "reservation.slotInPast": "Gi\u1EDD n\xE0y \u0111\xE3 tr\xF4i qua. Vui l\xF2ng ch\u1ECDn gi\u1EDD mu\u1ED9n h\u01A1n.",
  "reservation.slotUnavailable": "Khung gi\u1EDD n\xE0y v\u1EEBa h\u1EBFt ch\u1ED7. Vui l\xF2ng ch\u1ECDn gi\u1EDD kh\xE1c.",
  "reservation.bookingsPaused": "Nh\xE0 h\xE0ng t\u1EA1m d\u1EEBng nh\u1EADn \u0111\u1EB7t b\xE0n tr\u1EF1c tuy\u1EBFn \u0111\u1EBFn {{until}}. Vui l\xF2ng ch\u1ECDn gi\u1EDD mu\u1ED9n h\u01A1n ho\u1EB7c li\xEAn h\u1EC7 nh\xE0 h\xE0ng.",
  "reservation.notEditable": "\u0110\u1EB7t b\xE0n n\xE0y kh\xF4ng th\u1EC3 ch\u1EC9nh s\u1EEDa v\xEC \u0111\xE3 b\u1ECB h\u1EE7y, t\u1EEB ch\u1ED1i ho\u1EB7c \u0111\xE3 ho\xE0n t\u1EA5t.",
  "reservation.statusChanged": "\u0110\u1EB7t b\xE0n n\xE0y v\u1EEBa \u0111\u01B0\u1EE3c ng\u01B0\u1EDDi kh\xE1c thay \u0111\u1ED5i. Vui l\xF2ng ki\u1EC3m tra tr\u1EA1ng th\xE1i hi\u1EC7n t\u1EA1i r\u1ED3i th\u1EED l\u1EA1i.",
  "openingHours.exceptionOverlap": "Kho\u1EA3ng ng\xE0y n\xE0y \u0111\xE3 c\xF3 m\u1ED9t ngo\u1EA1i l\u1EC7 cho m\u1ED9t trong c\xE1c d\u1ECBch v\u1EE5 \u0111\xE3 ch\u1ECDn. \u0110\u1ED5i ng\xE0y ho\u1EB7c d\u1ECBch v\u1EE5 \u0111\u1EC3 kh\xF4ng b\u1ECB ch\u1ED3ng.",
  "openingHours.shiftsOverlap": "Hai kho\u1EA3ng gi\u1EDD trong c\xF9ng m\u1ED9t ng\xE0y b\u1ECB ch\u1ED3ng nhau. Vui l\xF2ng \u0111i\u1EC1u ch\u1EC9nh \u0111\u1EC3 ch\xFAng kh\xF4ng giao nhau.",
  "openingHours.shiftTimesEqual": "Gi\u1EDD m\u1EDF c\u1EEDa v\xE0 gi\u1EDD \u0111\xF3ng c\u1EEDa kh\xF4ng \u0111\u01B0\u1EE3c tr\xF9ng nhau.",
  "openingHours.invalidTimeFormat": "\u201C{{time}}\u201D kh\xF4ng ph\u1EA3i gi\u1EDD h\u1EE3p l\u1EC7. D\xF9ng \u0111\u1ECBnh d\u1EA1ng HH:mm.",
  "system.validationFailed": "Vui l\xF2ng ki\u1EC3m tra c\xE1c tr\u01B0\u1EDDng \u0111\u01B0\u1EE3c \u0111\xE1nh d\u1EA5u.",
  "system.unauthenticated": "Vui l\xF2ng \u0111\u0103ng nh\u1EADp l\u1EA1i.",
  "system.forbidden": "B\u1EA1n kh\xF4ng c\xF3 quy\u1EC1n th\u1EF1c hi\u1EC7n thao t\xE1c n\xE0y.",
  "system.notFound": "Kh\xF4ng t\xECm th\u1EA5y n\u1ED9i dung b\u1EA1n y\xEAu c\u1EA7u.",
  "system.conflict": "Kh\xF4ng th\u1EC3 th\u1EF1c hi\u1EC7n \u1EDF tr\u1EA1ng th\xE1i hi\u1EC7n t\u1EA1i.",
  "promotion.couponAlreadyIssued": "Kh\xE1ch h\xE0ng n\xE0y \u0111\xE3 c\xF3 phi\u1EBFu gi\u1EA3m gi\xE1 cho khuy\u1EBFn m\xE3i n\xE0y.",
  "promotion.codeInUse": 'M\xE3 "{{code}}" \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng.',
  "print.noPrinterConfigured": "Ch\u01B0a thi\u1EBFt l\u1EADp m\xE1y in cho bon n\xE0y.",
  "print.notPrintable": "Lo\u1EA1i \u0111\u01A1n h\xE0ng n\xE0y kh\xF4ng c\xF3 bon b\u1EBFp.",
  "system.badRequest": "Kh\xF4ng th\u1EC3 x\u1EED l\xFD y\xEAu c\u1EA7u n\xE0y.",
  "system.internal": "\u0110\xE3 x\u1EA3y ra l\u1ED7i. Vui l\xF2ng th\u1EED l\u1EA1i.",
  "worker.notFound": "Kh\xF4ng t\xECm th\u1EA5y nh\xE2n vi\xEAn.",
  "worker.notAssigned": "Nh\xE2n vi\xEAn n\xE0y ch\u01B0a \u0111\u01B0\u1EE3c ph\xE2n c\xF4ng \u1EDF \u0111\xE2y.",
  "worker.alreadyAssigned": "Ng\u01B0\u1EDDi n\xE0y \u0111\xE3 l\xE0m vi\u1EC7c t\u1EA1i nh\xE0 h\xE0ng n\xE0y.",
  "worker.emailTaken": "\u0110\xE3 t\u1ED3n t\u1EA1i t\xE0i kho\u1EA3n v\u1EDBi email n\xE0y.",
  "worker.lastManager": "\u0110\xE2y l\xE0 qu\u1EA3n l\xFD duy nh\u1EA5t \u2014 h\xE3y ph\xE2n c\xF4ng ng\u01B0\u1EDDi kh\xE1c tr\u01B0\u1EDBc.",
  "worker.selfRoleChange": "B\u1EA1n kh\xF4ng th\u1EC3 t\u1EF1 \u0111\u1ED5i vai tr\xF2 c\u1EE7a m\xECnh.",
  "worker.selfDeactivate": "B\u1EA1n kh\xF4ng th\u1EC3 v\xF4 hi\u1EC7u h\xF3a t\xE0i kho\u1EA3n c\u1EE7a ch\xEDnh m\xECnh.",
  "partner.selfRoleChange": "B\u1EA1n kh\xF4ng th\u1EC3 t\u1EF1 \u0111\u1ED5i vai tr\xF2 nh\xF3m c\u1EE7a m\xECnh.",
  "partner.selfRemove": "B\u1EA1n kh\xF4ng th\u1EC3 t\u1EF1 xo\xE1 m\xECnh kh\u1ECFi nh\xF3m.",
  "partner.lastGroupAdmin": "\u0110\xE2y l\xE0 admin duy nh\u1EA5t c\u1EE7a nh\xF3m - h\xE3y ch\u1EC9 \u0111\u1ECBnh admin kh\xE1c tr\u01B0\u1EDBc.",
  "partner.memberInactive": "Th\xE0nh vi\xEAn n\xE0y \u0111\xE3 b\u1ECB xo\xE1. H\xE3y m\u1EDDi l\u1EA1i.",
  "partner.memberChanged": "Ng\u01B0\u1EDDi kh\xE1c v\u1EEBa thay \u0111\u1ED5i th\xE0nh vi\xEAn n\xE0y. T\u1EA3i l\u1EA1i v\xE0 th\u1EED l\u1EA1i.",
  "worker.lastOwner": "\u0110\xE2y l\xE0 ch\u1EE7 s\u1EDF h\u1EEFu duy nh\u1EA5t - h\xE3y ch\u1EC9 \u0111\u1ECBnh ng\u01B0\u1EDDi kh\xE1c tr\u01B0\u1EDBc.",
  "user.emailTaken": "\u0110\xE3 c\xF3 t\xE0i kho\u1EA3n v\u1EDBi email n\xE0y.",
  "user.selfRevokeAdmin": "B\u1EA1n kh\xF4ng th\u1EC3 t\u1EF1 g\u1EE1 quy\u1EC1n system admin c\u1EE7a m\xECnh.",
  "user.lastSystemAdmin": "\u0110\xE2y l\xE0 system admin duy nh\u1EA5t - h\xE3y ch\u1EC9 \u0111\u1ECBnh ng\u01B0\u1EDDi kh\xE1c tr\u01B0\u1EDBc.",
  "label.systemOwned": "\u201C{{name}}\u201D l\xE0 nh\xE3n h\u1EC7 th\u1ED1ng v\xE0 kh\xF4ng th\u1EC3 x\xF3a. H\xE3y \u0111\u1ED5i t\xEAn nh\xE3n thay v\xEC x\xF3a.",
  "label.inUseByRule": "\u201C{{name}}\u201D \u0111ang \u0111\u01B0\u1EE3c m\u1ED9t quy t\u1EAFc d\u1ECDn d\u1EB9p s\u1EED d\u1EE5ng. H\xE3y g\u1EE1 nh\xE3n kh\u1ECFi quy t\u1EAFc ho\u1EB7c x\xF3a quy t\u1EAFc tr\u01B0\u1EDBc.",
  "purge.previewOutdated": "Danh s\xE1ch \u0111\xE3 thay \u0111\u1ED5i k\u1EC3 t\u1EEB l\xFAc b\u1EA1n xem: l\xFAc \u0111\xF3 {{expected}}, gi\u1EDD l\xE0 {{actual}}. Ch\u01B0a c\xF3 g\xEC b\u1ECB \u1EA9n. H\xE3y ki\u1EC3m tra l\u1EA1i tr\u01B0\u1EDBc khi \u1EA9n."
};

// src/themes.ts
var THEME_IDS = [
  "claret-cream",
  "linen-paprika",
  "lotus-jade",
  "sumi-gold",
  "porcelain-indigo",
  "blush-cinnabar"
];
var claretCream = {
  id: "claret-cream",
  label: "Claret & Porcelain",
  fonts: { heading: "--font-fraunces", body: "--font-hanken" },
  tokens: {
    "--radius": "0.5rem",
    /* Clean & COOL, never warm. Neutral near-white surfaces with only a
       whisper of cool so nothing reads yellow/cream. Pure-white cards lift
       off a faint cool-grey page — the "modern classic" surface. */
    "--background": "oklch(0.973 0.0015 264)",
    "--foreground": "oklch(0.215 0.008 265)",
    "--card": "oklch(1 0 0)",
    "--card-foreground": "oklch(0.215 0.008 265)",
    "--popover": "oklch(1 0 0)",
    "--popover-foreground": "oklch(0.215 0.008 265)",
    "--primary": "oklch(0.46 0.16 24)",
    "--primary-foreground": "oklch(0.99 0 0)",
    /* Secondary group — cool neutral greys, no warmth, no pink. */
    "--secondary": "oklch(0.945 0.003 264)",
    "--secondary-foreground": "oklch(0.28 0.01 265)",
    "--muted": "oklch(0.96 0.002 264)",
    "--muted-foreground": "oklch(0.5 0.008 265)",
    "--accent": "oklch(0.94 0.004 264)",
    "--accent-foreground": "oklch(0.28 0.02 265)",
    "--destructive": "oklch(0.56 0.215 27)",
    "--border": "oklch(0.9 0.003 264)",
    "--input": "oklch(0.9 0.003 264)",
    "--ring": "oklch(0.52 0.14 24)",
    "--olive": "oklch(0.58 0.13 150)",
    "--gold": "oklch(0.55 0.13 28)"
  }
};
var linenPaprika = {
  id: "linen-paprika",
  label: "Linen & Paprika",
  fonts: { heading: "--font-fraunces", body: "--font-hanken" },
  tokens: {
    "--radius": "0.875rem",
    "--background": "#f8f9fa",
    "--foreground": "oklch(0.248 0.028 45)",
    "--card": "oklch(0.992 0.01 92)",
    "--card-foreground": "oklch(0.248 0.028 45)",
    "--popover": "oklch(0.992 0.01 92)",
    "--popover-foreground": "oklch(0.248 0.028 45)",
    "--primary": "oklch(0.555 0.175 32)",
    "--primary-foreground": "oklch(0.985 0.012 90)",
    "--secondary": "oklch(0.918 0.03 82)",
    "--secondary-foreground": "oklch(0.3 0.03 45)",
    "--muted": "oklch(0.94 0.022 84)",
    "--muted-foreground": "oklch(0.5 0.03 55)",
    "--accent": "oklch(0.91 0.04 75)",
    "--accent-foreground": "oklch(0.3 0.04 45)",
    "--destructive": "oklch(0.5 0.205 25)",
    "--border": "oklch(0.87 0.025 78)",
    "--input": "oklch(0.87 0.025 78)",
    "--ring": "oklch(0.62 0.14 33)",
    "--olive": "oklch(0.52 0.07 128)",
    "--gold": "oklch(0.67 0.13 75)"
  }
};
var lotusJade = {
  id: "lotus-jade",
  label: "Lotus & Jade",
  fonts: { heading: "--font-cormorant", body: "--font-hanken" },
  tokens: {
    "--radius": "0.625rem",
    "--background": "#f8f9fa",
    "--foreground": "oklch(0.245 0.035 165)",
    "--card": "oklch(0.992 0.005 130)",
    "--card-foreground": "oklch(0.245 0.035 165)",
    "--popover": "oklch(0.992 0.005 130)",
    "--popover-foreground": "oklch(0.245 0.035 165)",
    "--primary": "#607A54",
    "--primary-foreground": "oklch(0.98 0.012 130)",
    "--secondary": "oklch(0.92 0.022 140)",
    "--secondary-foreground": "oklch(0.3 0.04 165)",
    "--muted": "oklch(0.94 0.012 140)",
    "--muted-foreground": "oklch(0.5 0.03 160)",
    "--accent": "oklch(0.9 0.03 140)",
    "--accent-foreground": "oklch(0.33 0.05 150)",
    "--destructive": "oklch(0.55 0.21 28)",
    "--border": "oklch(0.875 0.022 145)",
    "--input": "oklch(0.875 0.022 145)",
    "--ring": "oklch(0.55 0.08 140)",
    "--olive": "oklch(0.5 0.08 130)",
    "--gold": "oklch(0.66 0.13 78)"
  }
};
var sumiGold = {
  id: "sumi-gold",
  label: "Sumi & Gold",
  fonts: { heading: "--font-playfair", body: "--font-inter" },
  tokens: {
    "--radius": "0.25rem",
    "--background": "oklch(0.31 0.012 248)",
    "--foreground": "oklch(0.95 0.012 92)",
    "--card": "oklch(0.36 0.012 248)",
    "--card-foreground": "oklch(0.95 0.012 92)",
    "--popover": "oklch(0.36 0.012 248)",
    "--popover-foreground": "oklch(0.95 0.012 92)",
    "--primary": "oklch(0.78 0.14 82)",
    "--primary-foreground": "oklch(0.205 0.012 248)",
    "--secondary": "oklch(0.4 0.012 248)",
    "--secondary-foreground": "oklch(0.93 0.012 92)",
    "--muted": "oklch(0.38 0.01 248)",
    "--muted-foreground": "oklch(0.74 0.012 95)",
    "--accent": "oklch(0.42 0.014 245)",
    "--accent-foreground": "oklch(0.95 0.012 92)",
    "--destructive": "oklch(0.6 0.22 28)",
    "--border": "oklch(0.46 0.012 248)",
    "--input": "oklch(0.46 0.012 248)",
    "--ring": "oklch(0.82 0.14 82)",
    "--olive": "oklch(0.74 0.1 142)",
    "--gold": "oklch(0.78 0.14 82)"
  }
};
var porcelainIndigo = {
  id: "porcelain-indigo",
  label: "Porcelain & Indigo",
  fonts: { heading: "--font-fraunces", body: "--font-inter" },
  tokens: {
    "--radius": "0.75rem",
    "--background": "#f8f9fa",
    "--foreground": "oklch(0.27 0.02 262)",
    "--card": "oklch(0.995 0.003 255)",
    "--card-foreground": "oklch(0.27 0.02 262)",
    "--popover": "oklch(0.995 0.003 255)",
    "--popover-foreground": "oklch(0.27 0.02 262)",
    "--primary": "oklch(0.52 0.115 262)",
    "--primary-foreground": "oklch(0.99 0.004 255)",
    "--secondary": "oklch(0.955 0.008 255)",
    "--secondary-foreground": "oklch(0.32 0.025 262)",
    "--muted": "oklch(0.965 0.006 255)",
    "--muted-foreground": "oklch(0.52 0.022 262)",
    "--accent": "oklch(0.93 0.025 262)",
    "--accent-foreground": "oklch(0.32 0.05 262)",
    "--destructive": "oklch(0.55 0.21 28)",
    "--border": "oklch(0.905 0.01 255)",
    "--input": "oklch(0.905 0.01 255)",
    "--ring": "oklch(0.55 0.115 262)",
    "--olive": "oklch(0.6 0.07 200)",
    "--gold": "oklch(0.7 0.06 255)"
  }
};
var blushCinnabar = {
  id: "blush-cinnabar",
  label: "Blush & Cinnabar",
  fonts: { heading: "--font-fraunces", body: "--font-hanken" },
  tokens: {
    "--radius": "0.875rem",
    "--background": "#f8f9fa",
    "--foreground": "oklch(0.26 0.03 33)",
    "--card": "oklch(0.992 0.008 48)",
    "--card-foreground": "oklch(0.26 0.03 33)",
    "--popover": "oklch(0.992 0.008 48)",
    "--popover-foreground": "oklch(0.26 0.03 33)",
    "--primary": "oklch(0.565 0.145 28)",
    "--primary-foreground": "oklch(0.985 0.012 50)",
    "--secondary": "oklch(0.925 0.028 34)",
    "--secondary-foreground": "oklch(0.32 0.04 32)",
    "--muted": "oklch(0.946 0.016 38)",
    "--muted-foreground": "oklch(0.51 0.03 38)",
    "--accent": "oklch(0.912 0.038 28)",
    "--accent-foreground": "oklch(0.33 0.07 28)",
    "--destructive": "oklch(0.505 0.2 25)",
    "--border": "oklch(0.882 0.022 36)",
    "--input": "oklch(0.882 0.022 36)",
    "--ring": "oklch(0.6 0.13 28)",
    "--olive": "oklch(0.55 0.075 110)",
    "--gold": "oklch(0.68 0.125 72)"
  }
};
var themes = {
  "claret-cream": claretCream,
  "linen-paprika": linenPaprika,
  "lotus-jade": lotusJade,
  "sumi-gold": sumiGold,
  "porcelain-indigo": porcelainIndigo,
  "blush-cinnabar": blushCinnabar
};
var DEFAULT_THEME_ID = "claret-cream";
function resolveTheme(id) {
  const found = THEME_IDS.find((t) => t === id);
  return themes[found ?? DEFAULT_THEME_ID];
}

// src/config.ts
var DEFAULT_GENERAL_CONFIG = {
  timezone: "UTC",
  currency: "EUR",
  locale: "en",
  dateFormat: "DD/MM/YYYY",
  timeFormat: "24h"
};
var DEFAULT_PICKUP_CONFIG = {
  enabled: true,
  autoAccept: false,
  estimatedMinutes: 15,
  minOrderAmount: 0
};
var DEFAULT_DELIVERY_CONFIG = {
  enabled: false,
  autoAccept: false,
  estimatedMinutes: 30,
  minOrderAmount: 0,
  deliveryPriceMode: "DISTANCE",
  distanceCalculation: "DIRECT"
};
var DEFAULT_SCHEDULING_CONFIG = {
  enabled: true,
  maxDaysAhead: 7,
  slotInterval: 30,
  slotsPerInterval: 5
};
var DEFAULT_ORDER_CONFIG = {
  pickup: DEFAULT_PICKUP_CONFIG,
  delivery: DEFAULT_DELIVERY_CONFIG,
  scheduling: DEFAULT_SCHEDULING_CONFIG,
  pauseOrdering: {
    pickup: null,
    delivery: null
  }
};
var DEFAULT_RESERVATION_CONFIG = {
  enabled: false,
  arrivalTracking: "SIMPLE",
  partySize: { min: 1, max: 10 },
  advanceBookingDays: 30,
  lastMinuteCutoffHours: 2,
  slotInterval: 30,
  defaultDuration: 90,
  bufferTime: 0,
  autoConfirm: "AUTO",
  noShowGracePeriod: 15,
  freeCancellationHours: 24
};
var DEFAULT_NOTIFICATION_CONFIG = {
  printing: {
    autoPrintNewOrder: true,
    printerId: null
  }
};
var DEFAULT_RESTAURANT_CONFIG = {
  general: DEFAULT_GENERAL_CONFIG,
  ordering: DEFAULT_ORDER_CONFIG,
  reservation: DEFAULT_RESERVATION_CONFIG,
  notifications: DEFAULT_NOTIFICATION_CONFIG
};

// src/ops-feed.ts
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isOpsEventPayload(value) {
  if (!isRecord(value)) return false;
  if (value.kind === "RESERVATION_CREATED") {
    return isRecord(value.customer) && isRecord(value.openingHours) && isRecord(value.capacity) && isRecord(value.config);
  }
  if (value.kind === "ONLINE_ORDER_PLACED") {
    return isRecord(value.customer) && isRecord(value.openingHours) && isRecord(value.money) && Array.isArray(value.lines);
  }
  return false;
}
function opsWarnings(payload) {
  return payload.kind === "RESERVATION_CREATED" ? reservationWarnings(payload) : orderWarnings(payload);
}
function reservationWarnings(p) {
  const out = [];
  if (!p.openingHours.isOpen) out.push("Booked while the venue is closed for reservations");
  else if (p.openingHours.windows.length > 0 && !p.openingHours.matchedWindow) {
    out.push("Slot falls outside every opening window");
  }
  if (p.capacity.limit !== null && p.capacity.seatedBefore + p.partySize > p.capacity.limit) {
    out.push(
      `Overbooked: ${p.capacity.seatedBefore + p.partySize} covers against a limit of ${p.capacity.limit}`
    );
  }
  if (!p.capacity.shiftName) out.push("No shift matched \u2014 capacity was unbounded");
  if (p.partySize > p.config.maxPartySize) {
    out.push(`Party of ${p.partySize} exceeds the configured max of ${p.config.maxPartySize}`);
  }
  if (!p.customer.email && !p.customer.phone) {
    out.push("No email and no phone \u2014 the guest cannot be reached");
  }
  return out;
}
function orderWarnings(p) {
  const out = [];
  const m = p.money;
  const expected = m.subtotalCents - m.discountCents + m.deliveryFeeCents;
  if (expected !== m.totalCents) {
    out.push(
      `Total does not add up: ${m.subtotalCents} \u2212 ${m.discountCents} + ${m.deliveryFeeCents} = ${expected}, stored ${m.totalCents}`
    );
  }
  if (m.totalCents <= 0) out.push("Order total is zero or negative");
  if (m.taxCents > m.totalCents) out.push("Tax exceeds the total \u2014 prices are meant to be gross");
  if (p.itemCount === 0 || p.lines.length === 0) out.push("Order has no items");
  if (!p.openingHours.isOpen) out.push(`Placed while the venue is closed for ${p.orderType}`);
  if (p.orderType === "DELIVERY" && !p.delivery)
    out.push("Delivery order with no delivery details");
  if (p.delivery?.minimumOrderCents != null && m.subtotalCents < p.delivery.minimumOrderCents) {
    out.push(`Below the delivery minimum (${m.subtotalCents} < ${p.delivery.minimumOrderCents})`);
  }
  if (!p.customer.email && !p.customer.phone) {
    out.push("No email and no phone \u2014 the customer cannot be reached");
  }
  return out;
}

// src/telemetry-noise.ts
var IGNORED_CLIENT_ERRORS = [
  // Crypto wallet extensions inject a provider into every page and report
  // their own connection failures as page errors.
  /MetaMask/i,
  /ethereum provider/i,
  /window\.ethereum\.selectedAddress = undefined/,
  // Anything whose stack frames live in an extension bundle rather than ours.
  /chrome-extension:\/\//,
  /moz-extension:\/\//,
  /safari-(web-)?extension:\/\//,
  // Chrome's auto-translate rewrites text nodes underneath React, which then
  // fails to patch a node that moved. The stack is OUR code, so only the
  // message identifies it — an origin-based filter cannot catch this one.
  /Failed to execute '(insertBefore|removeChild|appendChild)' on 'Node'/,
  // A cross-origin script with no CORS headers: no message, no stack, nothing
  // actionable by anyone.
  /^Script error\.?(?:\s|$)/,
  // Layout-loop warnings the browser reports as errors; harmless by spec.
  /ResizeObserver loop/,
  /meta\[property='og:type'\]/,
  /^console\.error: (?:[Ll]oad failed|[Ff]ailed to fetch|[Nn]etwork error) (?:\w*Error|undefined)\b/
];
var OPAQUE_TRANSPORT_FAILURE_MESSAGE = /^(load failed|failed to fetch|networkerror when attempting to fetch resource\.?|network request failed|network error|the network connection was lost\.?)$/i;
var ADBLOCK_TARGETED_URL = /(?:^|[/-])(promo(?:tion)?s?|offers?|perks|coupons?)(?:[/?-]|$)/i;
function isLowSignalTransportError(report) {
  if (report.status !== 0) return false;
  if (report.url !== void 0 && ADBLOCK_TARGETED_URL.test(report.url)) return false;
  if (report.cause instanceof Error && report.cause.name === "AbortError") return true;
  return OPAQUE_TRANSPORT_FAILURE_MESSAGE.test(report.message.trim());
}
function classifyTransportFailure(report, client) {
  if (report.status !== 0) return "report";
  if (!client.online) return "drop";
  if (!isLowSignalTransportError(report)) return "report";
  return client.hidden ? "drop" : "log";
}

// src/online-payment-providers.ts
var ONLINE_PROVIDER_METHOD_IDS = ["paycat", "paypal"];
var ONLINE_PROVIDER_IDENTITY = {
  paycat: { methodId: "paycat", shortName: "Menucat", checkoutLabel: "Card online \xB7 Menucat" },
  paypal: { methodId: "paypal", shortName: "PayPal", checkoutLabel: "PayPal" }
};
var ONLINE_PROVIDER_METHOD_ID_BY_ENUM = {
  PAYCAT: "paycat",
  PAYPAL: "paypal"
};
function isOnlineProviderMethodId(value) {
  return ONLINE_PROVIDER_METHOD_IDS.includes(value);
}
function onlineProviderShortName(methodId) {
  if (!methodId || !isOnlineProviderMethodId(methodId)) return null;
  return ONLINE_PROVIDER_IDENTITY[methodId].shortName;
}

// src/payment-method-ids.ts
var CASH_METHOD_ID = "cash-on-handoff";
var CARD_ON_HANDOFF_METHOD_ID = "card-on-handoff";
var HANDOFF_METHOD_IDS = [CASH_METHOD_ID, CARD_ON_HANDOFF_METHOD_ID];
var PAYMENT_METHOD_NOTE_MAX_LENGTH = 24;

// src/purge-eligibility.ts
var PURGEABLE_PAYMENT_STATUS = {
  PENDING_COLLECTION: false,
  AWAITING_PROOF: false,
  PROOF_SUBMITTED: false,
  PROCESSING: false,
  ON_HOLD: false,
  PAID: false,
  REJECTED: true,
  VOID: true,
  REFUNDED: false,
  PARTIALLY_REFUNDED: false
};
var PURGEABLE_PAID_METHOD = {
  CASH: true,
  CARD_ON_HANDOFF: false,
  ONLINE: false,
  MANUAL: false,
  GIFT_CARD: false
};
var PURGEABLE_ORDER_STATUSES = [
  "COMPLETED" /* COMPLETED */,
  "CANCELLED" /* CANCELLED */
];
var PURGEABLE_RESERVATION_STATUSES = [
  "CANCELLED" /* CANCELLED */,
  "REJECTED" /* REJECTED */
];

// src/countries.ts
var COUNTRIES = [
  {
    code: "DE",
    name: "Germany",
    timezone: "Europe/Berlin",
    regionLabel: "Bundesland",
    defaultCurrency: "EUR",
    defaultLanguage: "de"
  },
  {
    code: "AT",
    name: "Austria",
    timezone: "Europe/Vienna",
    regionLabel: "Bundesland",
    defaultCurrency: "EUR",
    defaultLanguage: "de"
  },
  {
    code: "CH",
    name: "Switzerland",
    timezone: "Europe/Zurich",
    regionLabel: "Kanton",
    defaultCurrency: "CHF",
    defaultLanguage: "de"
  },
  {
    code: "FR",
    name: "France",
    timezone: "Europe/Paris",
    regionLabel: "R\xE9gion",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "NL",
    name: "Netherlands",
    timezone: "Europe/Amsterdam",
    regionLabel: "Province",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "BE",
    name: "Belgium",
    timezone: "Europe/Brussels",
    regionLabel: "Province",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "LU",
    name: "Luxembourg",
    timezone: "Europe/Luxembourg",
    regionLabel: "Canton",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "ES",
    name: "Spain",
    timezone: "Europe/Madrid",
    regionLabel: "Comunidad",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "IT",
    name: "Italy",
    timezone: "Europe/Rome",
    regionLabel: "Regione",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "PL",
    name: "Poland",
    timezone: "Europe/Warsaw",
    regionLabel: "Wojew\xF3dztwo",
    defaultCurrency: "PLN",
    defaultLanguage: "pl"
  },
  {
    code: "CZ",
    name: "Czechia",
    timezone: "Europe/Prague",
    regionLabel: "Kraj",
    defaultCurrency: "CZK",
    defaultLanguage: "cs"
  },
  {
    code: "GB",
    name: "United Kingdom",
    timezone: "Europe/London",
    regionLabel: "Region",
    defaultCurrency: "GBP",
    defaultLanguage: "en"
  },
  {
    code: "IE",
    name: "Ireland",
    timezone: "Europe/Dublin",
    regionLabel: "County",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "PT",
    name: "Portugal",
    timezone: "Europe/Lisbon",
    regionLabel: "Distrito",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "DK",
    name: "Denmark",
    timezone: "Europe/Copenhagen",
    regionLabel: "Region",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "SE",
    name: "Sweden",
    timezone: "Europe/Stockholm",
    regionLabel: "L\xE4n",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "NO",
    name: "Norway",
    timezone: "Europe/Oslo",
    regionLabel: "Fylke",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "FI",
    name: "Finland",
    timezone: "Europe/Helsinki",
    regionLabel: "Region",
    defaultCurrency: "EUR",
    defaultLanguage: "en"
  },
  {
    code: "US",
    name: "United States",
    timezone: "America/New_York",
    regionLabel: "State",
    defaultCurrency: "USD",
    defaultLanguage: "en"
  },
  {
    code: "CA",
    name: "Canada",
    timezone: "America/Toronto",
    regionLabel: "Province",
    defaultCurrency: "USD",
    defaultLanguage: "en"
  },
  {
    code: "VN",
    name: "Vietnam",
    timezone: "Asia/Ho_Chi_Minh",
    regionLabel: "T\u1EC9nh/Th\xE0nh ph\u1ED1",
    defaultCurrency: "VND",
    defaultLanguage: "vi"
  }
];
var COUNTRY_CODES = COUNTRIES.map((c) => c.code);
function getCountry(code) {
  if (!code) return void 0;
  const normalized = code.trim().toUpperCase();
  return COUNTRIES.find((c) => c.code === normalized);
}
function timezoneForCountry(code, fallback = "UTC") {
  return getCountry(code)?.timezone ?? fallback;
}
function languageForCountry(code) {
  return getCountry(code)?.defaultLanguage;
}

// src/media-url.ts
var MEDIA_SIZES = ["small", "medium", "large", "original"];
function mediaUrl(key, size, base = "") {
  if (/^https?:\/\//i.test(key)) return key;
  const safeKey = key.split("/").map(encodeURIComponent).join("/");
  return `${base.replace(/\/+$/, "")}/media/${size}/${safeKey}`;
}

// src/menu-pricing.ts
function byOrder(a, b) {
  if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
function priceGroupOf(product) {
  if (product.price !== 0) return null;
  const ordered = product.options.slice().sort(byOrder);
  const priceGroup = ordered.find((option) => option.isRequired && !option.isMultiple);
  return priceGroup?.id ?? null;
}

// src/option-selection.ts
function effectiveSelectBounds(option) {
  const max = option.isMultiple ? option.maxSelect : 1;
  const min = Math.max(option.minSelect, option.isRequired ? 1 : 0);
  return { min: max != null ? Math.min(min, max) : min, max };
}
function checkOptionSelection(option, pickedChoiceIds, validChoiceIds) {
  const unique = new Set(pickedChoiceIds);
  if (unique.size !== pickedChoiceIds.length) return { kind: "duplicate" };
  for (const id of unique) {
    if (!validChoiceIds.has(id)) return { kind: "unknownChoice", choiceId: id };
  }
  const { min, max } = effectiveSelectBounds(option);
  const picked = unique.size;
  if (picked < min) return { kind: "tooFew", min, picked };
  if (max != null && picked > max) return { kind: "tooMany", max, picked };
  return null;
}
function optionLimitsFit(limits, choiceCount) {
  const { minSelect, maxSelect } = limits;
  if (!Number.isInteger(minSelect) || minSelect < 0 || minSelect > choiceCount) return false;
  if (maxSelect == null) return true;
  return Number.isInteger(maxSelect) && maxSelect >= 1 && maxSelect <= Math.max(choiceCount, 1) && minSelect <= maxSelect;
}
function canMeetMinimum(option, availableChoiceCount) {
  return effectiveSelectBounds(option).min <= availableChoiceCount;
}
export {
  ALL_ERROR_CODES,
  Allergen,
  ApiError,
  ArrivalStatus,
  ArrivalTrackingMode,
  AutoConfirmMode,
  CARD_ON_HANDOFF_METHOD_ID,
  CASH_METHOD_ID,
  COUNTRIES,
  COUNTRY_CODES,
  CancelActor,
  CollectionMode,
  DE,
  DEFAULT_DELIVERY_CONFIG,
  DEFAULT_GENERAL_CONFIG,
  DEFAULT_NOTIFICATION_CONFIG,
  DEFAULT_ORDER_CONFIG,
  DEFAULT_PICKUP_CONFIG,
  DEFAULT_RESERVATION_CONFIG,
  DEFAULT_RESTAURANT_CONFIG,
  DEFAULT_SCHEDULING_CONFIG,
  DEFAULT_THEME_ID,
  DayOfWeek,
  DeliveryPriceMode,
  DeliveryZoneMode,
  DistanceCalculation,
  EN,
  ERROR_STATUS,
  ExceptionType,
  FranchiseRole,
  HANDOFF_METHOD_IDS,
  IGNORED_CLIENT_ERRORS,
  LocalOrderStatus,
  MEDIA_SIZES,
  NotificationChannel,
  ONLINE_PROVIDER_IDENTITY,
  ONLINE_PROVIDER_METHOD_IDS,
  ONLINE_PROVIDER_METHOD_ID_BY_ENUM,
  OrderItemStatus,
  OrderStatus,
  OrderType,
  PAYMENT_METHOD_NOTE_MAX_LENGTH,
  PL,
  PRODUCT_CODE_MAX_LENGTH,
  PRODUCT_CODE_SEPARATOR,
  PURGEABLE_ORDER_STATUSES,
  PURGEABLE_PAID_METHOD,
  PURGEABLE_PAYMENT_STATUS,
  PURGEABLE_RESERVATION_STATUSES,
  PartnerRole,
  PauseMode,
  PaymentMethod,
  PaymentMethodKind,
  PaymentStatus,
  ProductLabel,
  PurgeAgeBasis,
  PurgeLabelMatch,
  PurgeRunStatus,
  PurgeScheduleKind,
  PurgeSource,
  PurgeTarget,
  RefundReason,
  ReservationSource,
  ReservationStatus,
  RestaurantRole,
  ServiceType,
  ShiftMode,
  ShiftScope,
  SystemRole,
  THEME_IDS,
  TableAttribute,
  TableSessionStatus,
  TableState,
  TimeFormat,
  VI,
  canMeetMinimum,
  checkOptionSelection,
  classifyTransportFailure,
  effectiveSelectBounds,
  errorMessage,
  formatMoney,
  formatOrderLineChoices,
  formatProductLabel,
  getCountry,
  inputToMinor,
  interpolate,
  isLowSignalTransportError,
  isOnlineProviderMethodId,
  isOpsEventPayload,
  languageForCountry,
  mediaUrl,
  minorUnitFactor,
  moneyToInput,
  needsStaticDeliveryMinutes,
  normalizeProductCode,
  onlineProviderShortName,
  opsWarnings,
  optionLimitsFit,
  priceGroupOf,
  productCodeKey,
  resolveLocalized,
  resolveLocalizedJson,
  resolveTheme,
  targetZoneMode,
  themes,
  timezoneForCountry,
  toMinorUnits,
  unwrap
};
//# sourceMappingURL=index.mjs.map